import(/* webpackMode: "eager", webpackExports: ["PageEvents"] */ "/codebuild/output/src3883966605/src/apps/nextjs-bigcommerce/components/analytics/layout/page-events.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RenderBuilderSection"] */ "/codebuild/output/src3883966605/src/apps/nextjs-bigcommerce/components/builder/builder-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3883966605/src/apps/nextjs-bigcommerce/components/schema/homepage-schema.tsx");
